import { DocUploader } from "@portal/BaseComponents/Document/DocUpload/DocUploader";
import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import { Files } from "@portal/types/file";
import { NonUndefined } from "@portal/types/utils";
import { AddComment, GrowTypography } from "@sinecycle/growcomponents";
import { UploadFile } from "antd";
import { UploadChangeParam } from "antd/es/upload";
import { useAtomValue } from "jotai";
import { useState } from "react";
export type CommentContent = Parameters<
  NonUndefined<React.ComponentProps<typeof AddComment>["handleSave"]>
>["0"] & {
  file_upload_id?: string[];
};
interface CommentFooterProps {
  handleSave?: (value: CommentContent) => void;
}

function CommentFooter(props: CommentFooterProps) {
  const config = useAtomValue(userConfigAtom);
  const [uploadIds, setUploadIds] = useState<string[]>();
  const [disable, setDisable] = useState(false);
  const updateUploadIds = (fileList: UploadFile<Files>[]) => {
    const ids = fileList?.map((file) => file.response?.id) as string[];
    setUploadIds(ids);
  };

  function handleChange(info: UploadChangeParam<UploadFile<Files>>) {
    updateUploadIds(info.fileList);
    setDisable(info.file.status === "uploading");
  }
  const Attachments = (
    <DocUploader
      action="/api/v1/attachments"
      previewType="UPLOADED"
      onChange={handleChange}
      className={uploadIds?.length ? "" : "uploaded"}
    />
  );
  const Heading = (
    <GrowTypography.Text strong>{`${config.user_details?.user.first_name} ${
      config.user_details?.user.last_name ?? ""
    }`}</GrowTypography.Text>
  );
  return (
    <AddComment
      heading={Heading}
      convertedValue
      handleSave={(value) => {
        props.handleSave?.({ ...value, file_upload_id: uploadIds });
      }}
      hideMentions
      private_details={{ hidePrivate: true }}
      extraComponent={Attachments}
      disable={disable}
      hasExtraValue={Boolean(uploadIds?.length)}
    />
  );
}

export { CommentFooter };
